<template>
  <div class="container-fluid">
    <ModalEditionEffectifs ref="modalEditionEffectifs" :titre="nomLieuConsommation" :effectifs="effectifsDetailles"
      :typesConvives="convivesTypesNonNeutre" :structuresMenus="structures" :typesServices="services" :typesRegimes="regimes" :typesTextures="textures" :key="'detail'+keyEffectifsDetaillesModifies"
      @modifier-effectifs="effectifsModifiesPourSynthese($event)" />

    <BarreActions :actions="actions" @appliquer-action="executerAction($event)" />

    <div class="card height-responsive">
      <div class="card-header">Paramétrage du lieu de consommation : {{ nomLieuConsommation }}</div>
      <div class="card-body height-responsive-body height-responsive-1b">
        <EditionLieuConsommation :lieuConsommationId="lieuConsommationId" :structures="structures" :barquettes="barquettes" :effectifsDetailles="effectifsPourSynthese" 
          @lieu-modifie="lieuModifie($event)" @effectifs-modifies="effectifsDetaillesModifies($event)" @donnees-modifiees="donneesModifiees($event)" />
      </div>
    </div>
  </div>
</template>

<script>
import BarreActions from '@/components/Divers/BarreActions'
import EditionLieuConsommation from "@/components/Menus/EditionLieuConsommation"
import ModalEditionEffectifs from "@/components/Menus/ModalEditionEffectifs"
import { connecteData } from "@/mixins/connecteData"
import { chargerToutesLesStructures } from '@/api/gpao/menus'
import { obtenirBarquettes } from '@/api/gpao/production'
import { Nombre } from '@/helpers/utils'
import { mapGetters } from "vuex"
import _ from 'lodash'

export default {
  name: "PageLieuConsommationEdition",
  // props: {
  //   "action": String,
  //   //"lieuConsommationId": Number
  // },
  components: { BarreActions, EditionLieuConsommation, ModalEditionEffectifs },
  mixins: [ connecteData ],
  data() {
    return {
      keyEffectifsDetaillesModifies: 1,
      keyEffectifsModifiesPourSynthese: 1,
      lieuConsommationId: null,
      lieuConsommation: null,
      effectifsDetailles: [],
      effectifsPourSynthese: [],
      structures: [],
      barquettes: [],
      actions: {
        // Boutons à afficher dans la barre d'action
        // Exemple :
        /*
        nomAction: {
          label: Label affiché sur le bouton (string),
          disabled: Etat actif/inactif par défaut du bouton (bool),
          class: Classe CSS (btn-primary, btn-success, btn-warning ou btn-danger) à appliquer sur le bouton (par défaut : "btn-primary" est appliqué => il s'agit du bouton bleu Agap'pro) (string)
          methode(contexte) {
            // => contexte équivaut à this (mais this ne fonctionne pas car l'initialisation de data n'est pas encore terminée, donc data n'est pas encore rattaché à this)
            traitements à exécuter lors du clic sur le bouton
            les traitements définis dans cette page doivent être appelés sous la forme : contexte.traitement()

            Remarque : pour que le système fonctionne, il faut déclarer la méthode ci-dessous dans la section "methods" de cette page
            executerAction(methode) {
              methode(this)
            }

          }
        }
        */
        ajouterTypeConvive: {
          label: "Ajouter un type de convive",
          methode(contexte) {
            contexte.addTypeConvive()
          }
        },
        detailEffectifs: {
          label: "Effectifs détaillés",
          methode(contexte) {
            contexte.$refs.modalEditionEffectifs.show()
          }
        },
        retour: {
          label: "Retour",
          methode(contexte) {
            contexte.$router.push({ name: "LieuxConsommation", params: { etablissementId: contexte.etabCourantId } })
          }
        },
        annuler: {
          label: "Annuler",
          disabled: true,
          class: "btn-danger",
          async methode(contexte) {
            let result = await contexte.alerteConfirmation("Annuler les modifications", "Vos modifications seront définitivement perdues.<br/>Souhaitez-vous annuler vos modifications ?")
            if (result) {
              contexte.commande = _.cloneDeep(contexte.donneesInitiales)
              contexte.actions.disableSiEnvoyeOuReceptionne(contexte.actions, contexte.commandeEnvoyeeOuReceptionnee())
              contexte.actions.recalculer.hidden = !contexte.commandeDepuisMenu()
            }
          }
        },
        enregistrer: {
          label: "Enregistrer",
          disabled: true,
          class: "btn-success",
          methode(contexte) {
            contexte.enregistrer()
          }
        },
        // Appeler "this.actions.initialiser(this)"" dans mounted() => génère les tableaux d'actions utilisés pour afficher les boutons à gauche et à droite de la barre d'actions
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.actions.barreGauche = [ contexte.actions.ajouterTypeConvive, contexte.actions.detailEffectifs ]
          contexte.actions.barreDroite = [ contexte.actions.retour, contexte.actions.annuler, contexte.actions.enregistrer ]
        },
        // A gérer en cas de boutons à activer/désactiver (créer une méthode par groupe de boutons à activer/désactiver)
        disable(actions, disabled) {
          let actionsATraiter = [ actions.annuler, actions.enregistrer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        }
      }
    }
  },
  computed: {
    ...mapGetters("definitions", ["convivesTypesNonNeutre", "services", "regimes", "textures"]),
    nomLieuConsommation() {
      return this.lieuConsommation?.libelle ?? ""
    },
    // ...mapGetters("definitions", ["convivesTypesNonNeutre", "regimes", "textures", "services"]),
    // optionsConviveType() { return this.convivesTypesNonNeutre },
    // optionsRegimes() { return this.regimes },
    // optionsTextures() { return this.textures },
    // optionsServices() { return this.services },
    // lectureSeule() { return !this.lieuEnCours?.actif ?? true },
    // effectifsEnCours() {
    //   return this.lieuEnCours?.typesConvives?.map(tc => tc.syntheseEffectifs)?.filter(x => x.effectif !== -1) || []
    // },
    // typesConvivesEnCours() {
    //   let tc = [...new Set(this.effectifsEnCours.map(e => e.typeConviveId))]
    //   debugger
    //   return [...new Set(this.effectifsEnCours.map(e => e.typeConviveId))]
    // },
    // nomValide() {
    //   return this.lieuEnCours?.libelle?.length > 3
    // },
    // lieuValide() {
    //   // Vérification du nom du lieu de consommation
    //   if (!this.nomValide)
    //     return false  // Nom du lieu invalide

    //   // Vérification de la présence d'au moins un type de convive
    //   if (!this.lieuEnCours.typesConvives?.length)
    //     return false

    //   // Vérification de la présence d'au moins un effectif pour chaque type de convive
    //   if (this.lieuEnCours.typesConvives.some(tc => !tc.syntheseEffectifs?.filter(e => e.effectifs)?.length))
    //     return false

    //   // Vérification de la saisie correcte de chaque effectif
    //   if (this.lieuEnCours.typesConvives.some(tc => tc.syntheseEffectifs.some(e => !e.structureMenuId || !e.typeRegimeId || !e.typeTextureId)))
    //     return false

    //   // Vérification de la présence de doublons de types de convives
    //   if (this.lieuEnCours.typesConvives.some(tc => this.estDoublon(tc, this.lieuEnCours.typesConvives)))
    //     return false

    //   // Vérification de la présence de doublons d'effectifs au sein de chaque type de convive
    //   if (this.lieuEnCours.typesConvives.some(tc => tc.syntheseEffectifs.some(e => this.estDoublon(e, tc.syntheseEffectifs))))
    //     return false

    //   return true
    // }
  },
  methods: {
    executerAction(methode) {
      // Nécessaire pour faire fonctionner les actions de la barre d'actions'
      methode(this)
    },
    // lieuCharge(lieu) {
    //   this.lieuConsommation = lieu
    // },
    lieuModifie(lieu) {
      this.lieuConsommation = lieu
      this.keyEffectifsDetaillesModifies++
      this.keyEffectifsModifiesPourSynthese++
    },
    effectifsDetaillesModifies(effectifs) {
      this.effectifsDetailles = effectifs
      this.keyEffectifsDetaillesModifies++
    },
    effectifsModifiesPourSynthese(effectifs) {
      this.effectifsPourSynthese = effectifs
      this.keyEffectifsModifiesPourSynthese++
    },
    donneesModifiees(donneesModifiees) {
      this.actions.disable(this.actions, !donneesModifiees)
    },
    // async initialiserModale() {
    //   if (this.action === "ajouter") {
    //     debugger
    //     this.lieuEnCours = this.creerNouveauLieu()
    //     //this.addTypeConvive()
    //   } else {
    //     let response = await getLieuConsommation(this.lieuConsommationId)
    //     this.lieuEnCours = response.data
    //   }

    //   this.lieuEnCours.typesConvives.forEach(tc => {
    //     tc.typeConviveChoisi = { id: tc.typeConviveId, nom: tc.nomTypeConvive }
    //     tc.syntheseEffectifs = this.detailVersRecap(tc.effectifs, true)
    //   })
    //   this.checkLieu()
    // },
    // creerNouveauLieu() {
    //   let nouveauLieu = {
    //     etablissementId: this.etabCourantId,
    //     actif: true,
    //     libelle: 'Nouveau lieu',
    //     typeLiaisonId: null,
    //     adresse1: '',
    //     adresse2: '',
    //     adresse3: '',
    //     codePostal: '',
    //     ville: '',
    //     joursOuverture: [],
    //     // effectifsParDefaut: [],
    //     // typesConvives: []
    //     // typesConvives: [{
    //     //   typeConviveId: null,
    //     //   effectifs: [{
    //     //     typeConviveId: null,
    //     //     structureMenuId: null,
    //     //     typeServiceId: null,
    //     //     typeRegimeId: null,
    //     //     typeTextureId: null,
    //     //     effectifs: 0,
    //     //     aPlatTemoin: false,
    //     //     jour: null
    //     //   }]
    //     // }]
    //     //ordreLivraison: this.lieux.length ? Math.max.apply(Math, this.lieux.map(l => l.ordreLivraison)) + 1 : 1,
    //     //barquettes: _.cloneDeep(this.listeBarquettes) //Toutes les barquettes sélectionnées par défaut
    //   }
    //   this.addTypeConvive(nouveauLieu)
    //   return nouveauLieu
    // },
    // show() {
    //   this.$refs.modalEditionLieuConsommation.show()
    // },
    // // show(lieu, listeBarquettes) {
    // //   if (!lieu)
    // //     return
      
    // //   //this.lieuEnCours = {...lieu}
    // //   this.lieuEnCours = _.cloneDeep(lieu)
    // //   this.listeBarquettes = listeBarquettes || []

    // //   this.checkLieu()
    // //   this.$refs.modalEditionLieuConsommation.show()
    // // },
    // hide() {
    //   this.$refs.modalEditionLieuConsommation.hide()
    // },
    // selectionnerTypeConvive(typeConviveAModifier, typeConviveChoisi) {
    //   typeConviveAModifier.typeConviveId = typeConviveChoisi.id
    //   typeConviveAModifier.nomTypeConvive = typeConviveChoisi.nom

    //   // // Mise à jour du type de convive sur la synthèse des effectifs
    //   // typeConviveAModifier.syntheseEffectifs.forEach(e => {
    //   //   e.typeConviveId = typeConviveChoisi.id
    //   //   e.nomTypeConvive = typeConviveChoisi.nom
    //   // })

    //   // // Mise à jour du type de convive sur les effectifs
    //   // typeConviveAModifier.effectifs.forEach(e => {
    //   //   e.typeConviveId = typeConviveChoisi.id
    //   //   e.nomTypeConvive = typeConviveChoisi.nom
    //   // })
    // },
    // selectionnerStructureMenu(structureMenuAModifier, structureMenuChoisie) {
    //   structureMenuAModifier.structureMenuId = structureMenuChoisie.id
    //   structureMenuAModifier.nomStructureMenu = structureMenuChoisie.nom
    // },
    // selectionnerTypesServices(typesServicesAModifier, typesServicesChoisis) {
    //   typesServicesAModifier.typeServiceId = typesServicesChoisis.id
    //   typesServicesAModifier.nomTypeService = typesServicesChoisis.nom
    // },
    // selectionnerTypeRegime(typeRegimeAModifier, typeRegimeChoisi) {
    //   typeRegimeAModifier.typeRegimeId = typeRegimeChoisi.id
    //   typeRegimeAModifier.nomTypeRegime = typeRegimeChoisi.nom
    // },
    // selectionnerTypeTexture(typeTextureAModifier, typeTextureChoisi) {
    //   typeTextureAModifier.typeTextureId = typeTextureChoisi.id
    //   typeTextureAModifier.nomTypeTexture = typeTextureChoisi.nom
    // },
    // ModifierSyntheseEffectif(ancienEffectif, nouvelEffectif) {
    //   // Recherche des effectifs à modifier
    //   let anciensEffectifs = 
    // },
    creerStructureMenu() {
      this.$refs.editionStructureMenu.afficherModal()
    },
    ouvrirStructureMenu(structureMenuId) {
      this.$refs.editionStructureMenu.afficherModal(structureMenuId)
    },
    supprimerEffectif(effectif) {
      effectif.effectif = -1
    },
    afficherEffectifsDetailles() {

    },
    // effectifsTypeConvive(typeConviveId) {
    //   //let e = this.effectifsEnCours
    //   //debugger
    //   return this.effectifsEnCours.filter(e => e.typeConviveId === typeConviveId)
    // },
    addTypeConvive(lieu) {
      if (!lieu)
        lieu = this.lieuEnCours

      if (!lieu.typesConvives)
        lieu.typesConvives = []

      let nouveauTypeConvive = { typeConviveId: null, nomTypeConvive: "", effectifs: [], syntheseEffectifs: [] }
      this.addEffectif(nouveauTypeConvive)

      lieu.typesConvives.push(nouveauTypeConvive)
      //this.lieuEnCours.typesConvives.push({ structureMenuId: null, typeServiceId: null, typeRegimeId: null, typeTextureId: null, effectifs: 0, barquettes: [] })
    },
    addEffectif(typeConvive) {
      if (!typeConvive.syntheseEffectifs)
        typeConvive.syntheseEffectifs = []
      typeConvive.syntheseEffectifs.push({ structureMenuId: null, typeServiceId: null, typeRegimeId: null, typeTextureId: null, effectifs: 0, barquettes: this.barquettes })
    },
    // checkLieu() {
    //   if (!this.lieuEnCours.joursOuverture) {
    //     // Initialisation de la liste des jours
    //     this.lieuEnCours.joursOuverture = []
    //   }
    //   if (!this.lieuEnCours.typesConvives?.length) {
    //     // Initialisation de la liste des effectifs
    //     this.addTypeConvive()
    //   } else {
    //     // Mise en forme correcte des régimes et textures avec de ne pas avoir de valeur vide dans les configuration
    //     // => permet de corriger les anciennes configurations créées avant la mise en place des contrôles de saisie
    //     let regimeNormalId = [...this.regimes].sort((t1, t2) => t1.ordre - t2.ordre).first()?.value
    //     let textureNormaleId = [...this.textures].sort((t1, t2) => t1.ordre - t2.ordre).first()?.value
    //     if (!regimeNormalId && !textureNormaleId) {
    //       return
    //     }
    //     this.lieuEnCours.typesConvives.map(tc => tc.syntheseEffectifs).forEach(e => {
    //       if (!e.typeRegimeId && regimeNormalId) {
    //         e.typeRegimeId = regimeNormalId
    //       }
    //       if (!e.typeTextureId && textureNormaleId) {
    //         e.typeTextureId = textureNormaleId
    //       }
    //     })
    //   }
    // },
    enregistrerLieu() {
      this.$emit("enregistrer-lieu", this.lieuEnCours)
    },
    annulerEdition() {
      this.$emit("annuler-edition")
    },
    enregistrerBarquettesLieu(dataBarquettes) {
      
      this.lieuEnCours.barquettes = []
      dataBarquettes.forEach(b => {
        this.lieuEnCours.barquettes.push(this.barquettes.filter(x => x.id === b.Id).first())
      })

      /*var data = this.lieuEnCours.donneesSupplementaires && JSON.parse(this.lieuEnCours.donneesSupplementaires.replaceAll("'", "\"")) || {}
      data.Barquettage = dataBarquettes
      this.lieuEnCours.donneesSupplementaires = JSON.stringify(data).replaceAll("\"", "'")*/

    },
    enregistrerBarquettesEffectif(effectif, dataBarquettes) {
      
      effectif.barquettes = []
      dataBarquettes.forEach(b => {
        effectif.barquettes.push(this.barquettes.filter(x => x.id === b.Id).first())
      })

      /*var data = effectif.donneesSupplementaires && JSON.parse(effectif.donneesSupplementaires.replaceAll("'", "\"")) || {}
      data.Barquettage = dataBarquettes
      effectif.donneesSupplementaires = JSON.stringify(data).replaceAll("\"", "'")*/
    },
    jourChanged(jour, ouvert) {
      if (ouvert.target.checked) {
        this.lieuEnCours.joursConsommation.push(jour)
      } else {
        _.remove(this.lieuEnCours.joursConsommation, e => e === jour)
      }
    },
    afficherTexteAEffectif(typeConvive) {
      //debugger
      let nbEffectifs = 0
      if (typeConvive?.syntheseEffectifs?.length) {
        nbEffectifs = typeConvive.syntheseEffectifs.map(e => e.effectifs).reduce((a,c) => a + c, 0)
      }
      let capaciteAccueil = "Capacité d'accueil : " + nbEffectifs

      if (!typeConvive?.nomTypeConvive)
        return capaciteAccueil

      // if (!effectif || (effectif && !effectif.structureMenuId))
      //   return capaciteAccueil
      
      let informations = [
        typeConvive?.nomTypeConvive,
        capaciteAccueil
      ]

      return informations.filter(i => i).join(" - ")
    },
    estDoublon(element, liste) {
      let doublons = []
      if (element.structureMenuId) {
        // Nous sommes sur un effectif car ce sont les effectifs qui portent les structures de menus
        doublons = liste.filter(e => e.structureMenuId == element.structureMenuId && e.typeServiceId == element.typeServiceId
          && e.typeRegimeId == element.typeRegimeId && e.typeTextureId == element.typeTextureId) || []
      } else {
        // Nous sommes sur un type de convive dans le cas contraire
        doublons = liste.filter(e => e.typeConviveId == element.typeConviveId) || []
      }
      return doublons.length > 1
    },
    async chargerBarquettes() {
      // Chargement des barquettes possibles
      let ret = await obtenirBarquettes(this.etabCourantId)
      this.barquettes = ret.data || []
    },
    async chargerStructuresMenus() {
      // Chargement des structures de menus
      let ret = await chargerToutesLesStructures(this.etabCourantId)
      this.structures = ret.data || []
    }
  },
  created() {
    this.lieuConsommationId = Nombre(this.$route.params.lieuConsommationId)
  },
  mounted() {
    // Les structures et les barquettes sont des données qui ne sont pas vouées à être modifiées dans le cadre de cette fonctionnalité
    // Elles sont donc chargées ici et non dans le composant d'édition du lieu de consommation afin de les charger uniquement à l'ouverture de la page et de ne pas les recharger à chaque ouverture de modale
    this.chargerStructuresMenus()
    this.chargerBarquettes()
    
    this.actions.initialiser(this)
  }
}

</script>
